import classNames from 'classnames';
import React, {
  MutableRefObject,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState
} from 'react';

import styles from './Toggle.module.scss';

export interface ToggleApi {
  off: () => void;
}

export interface ToggleProps {
  className?: string;
  label?: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  apiRef?: MutableRefObject<ToggleApi>;
}

export function Toggle(props: ToggleProps) {
  const { className, label, checked, onChange, disabled, apiRef } = props;
  const [isChecked, setChecked] = useState(checked || false);

  const toggleLabel = label || (isChecked ? 'Enabled' : 'Disabled');

  const handleToggle = () => {
    setChecked(!isChecked);

    if (onChange) {
      onChange(!isChecked);
    }
  };

  const off = useCallback(() => {
    setChecked(false);
  }, []);

  useEffect(() => {
    setChecked(checked);
  }, [checked]);

  useImperativeHandle(apiRef, () => ({ off }), [off]);

  return (
    <div
      className={classNames(
        styles.toggleSwitch,
        {
          [styles.checked]: isChecked,
          [styles.disabled]: disabled
        },
        className
      )}
    >
      <label>
        <input type="checkbox" checked={isChecked} onChange={handleToggle} />
        <span className={styles.slider}></span>
        <span className={styles.toggleLabel}>{toggleLabel}</span>
      </label>
    </div>
  );
}
